//Importaciones
import React from 'react'
import { MessageBar, MessageBarType } from '@fluentui/react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import { isNullUndefinedOrEmpty } from '../../../common/Helpers';
import { useTranslation } from 'react-i18next';

function MessageBoxInfoComplex(props) {
    //Helpers
    const { t } = useTranslation();

    //Parametros de entrada.
    const { inputParam_TranslateText = false, inputParam_Display = true, inputParam_Message = null, inputParam_MessageType, inputParam_Width = "100%", inputParam_ShowClose = false, inputParam_SetterMessage = null, inputParam_CustomSetterMessage = false  } = props;

    //Parametros de componente.

    //Funciones de componente.

    //Eventos de componente.
    const onCloseSuccessMessageBar = () => {
        if (inputParam_CustomSetterMessage) {
            inputParam_SetterMessage && inputParam_SetterMessage(false)
        }
        else {
            inputParam_SetterMessage && inputParam_SetterMessage(prevState => ({
                ...prevState,
                showMessage : false,
            }));
        }
    }

    //Render de componente.
    return (
        <div style={ { zIndex: 2, width: inputParam_Width, display: `${inputParam_Display ? "inline-block" : "none"}` } }>
            <MessageBar
                dismissButtonAriaLabel={ inputParam_ShowClose ? t('data-lang-lbl-close') : undefined }
                onDismiss={ inputParam_ShowClose ? ()=> onCloseSuccessMessageBar() : null }
                isMultiline={true}
                messageBarType={ inputParam_MessageType === "success" ? MessageBarType.success : (inputParam_MessageType === "error" ? MessageBarType.error : (inputParam_MessageType === "warning" ? MessageBarType.warning : MessageBarType.info)) }
            >
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(inputParam_TranslateText ? (Array.isArray(inputParam_Message) ? inputParam_Message.map(x => `${t(x)}<br>`).join("") : t(inputParam_Message)) : (Array.isArray(inputParam_Message) ? inputParam_Message.map(x => `${t(x)}<br>`).join("") : inputParam_Message), { USE_PROFILES: { html: true } }) }}></div>
            </MessageBar>
        </div>
    );
}

///Proptypes
MessageBoxInfoComplex.propTypes = {
    inputParam_Message: PropTypes.string.isRequired,
    inputParam_Width: PropTypes.string,
};

export default MessageBoxInfoComplex;